/**
 * Switchboard API endpoints
 * Includes all endpoints needed for switchboard operations and supporting data
 */
export const SWITCHBOARD_ENDPOINTS = {
  // Switchboard operations
  LIST: '/app/v1/switchboards/',
  DETAIL: (extensionDialPlan: number) =>
    `/app/v1/switchboards/${extensionDialPlan}/`,
  CREATE: '/app/v1/switchboards/',
  UPDATE: (extensionDialPlan: number) =>
    `/app/v1/switchboards/${extensionDialPlan}/`,
  DELETE: (extensionDialPlan: number) =>
    `/app/v1/switchboards/${extensionDialPlan}/`,

  // PBX operations
  PBX_DETAIL: (pbxId: number) => `/app/v2/pbxes/${pbxId}/`,
  PBX_UPDATE: (pbxId: number) => `/app/v2/pbxes/${pbxId}/`,

  // Supporting data for switchboard nodes
  EXTENSIONS_LIST: '/app/v1/extensions/',
  MESSAGE_GROUPS_LIST: '/app/v1/message-groups/',
  SOUND_CLIPS_LIST: '/app/v1/sound-clips/',
  SOUND_CLIP_DETAIL: (id: number) => `/app/v1/sound-clips/${id}/`,
  SCHEDULES_LIST: '/app/v1/schedules/',
  PHONE_NUMBERS_LIST: '/app/v2/phone-numbers/',
} as const
